import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';

import { NBSP } from '../../../../constants/symbols';

interface IBackButtonProps {
  onClick: () => void;
  href: string;
}

export const GoToChatButton: React.FC<IBackButtonProps> = ({ onClick, href }) => {
  return (
    <LinkButton size="M" href={href} onClick={onClick}>
      {`Перейти в${NBSP}чат`}
    </LinkButton>
  );
};
